import src from "IMAGE";
export default { src, width: 197, height: 99, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAARklEQVR42mWNOwrAMAxDc//L5QLGo0d/wOAlWKWFgiGahN4DLYyYGapqTmf9rbux94aI3MILVRVEBGaGu99CZiIiPjhuzgMwE3yNars01wAAAABJRU5ErkJggg=="};
